import { SmartCaptcha } from '@yandex/smart-captcha';
import {FC, memo, useCallback, useState} from "react";

// @ts-ignore
export const Captcha = ({CaptchaState}) => {
    const [token, setToken] = useState('');
    const [status, setStatus] = useState('hidden');

    const [resetCaptcha, setResetCaptcha] = useState(0);

    /* Update the state */
    const handleReset = () => setResetCaptcha((prev) => prev + 1);

    const handleChallengeVisible = useCallback(() => setStatus('visible'), []);
    const handleChallengeHidden = useCallback(() => setStatus('hidden'), []);
    const handleNetworkError = useCallback(() => setStatus('network-error'), []);
    const handleSuccess = useCallback((token: string) => {
        CaptchaState(true);
        setStatus('success');
        setToken(token);
    }, []);
    const handleTokenExpired = useCallback(() => {
        setStatus('token-expired');
        setToken('');
    }, []);

    let captcha = process.env.REACT_APP_CAPTCHA;

    return (

            <SmartCaptcha
                key={resetCaptcha}
                sitekey={captcha}
                onChallengeVisible={handleChallengeVisible}
                onChallengeHidden={handleChallengeHidden}
                onNetworkError={handleNetworkError}
                onSuccess={handleSuccess}
                onTokenExpired={handleTokenExpired}
            />

    );
};
